"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forceRefreshAppConfig = exports.fetchAndActivateAppConfig = exports.waitForAppConfig = exports.getAppConfig = exports.APP_CONFIG_DEFAULTS = void 0;
const remote_config_1 = require("firebase/remote-config");
exports.APP_CONFIG_DEFAULTS = {
    // Crew feed scoring
    decayHalfLifeDays: 7,
    newnessBonusPoints: 3,
    newnessWindowDays: 2,
    reservedSlots: 3,
    reservedMaxAgeHours: 48,
    // Feature flags
    featureQuickTakesEnabled: true,
    featureWatchNowEnabled: true,
    featureThisOrThatEnabled: true,
    featureWaitlistEnabled: false,
    featureImportEnabled: 'disabled',
    // Emergency controls
    appMaintenanceMode: false,
    // UI experiments
    featureGlassmorphicMovieCard: true,
};
let _config = Object.assign({}, exports.APP_CONFIG_DEFAULTS);
let _readyPromise = null;
function getAppConfig() {
    return _config;
}
exports.getAppConfig = getAppConfig;
/**
 * Resolves once the first Remote Config fetch has completed (or failed).
 * If called before fetchAndActivateAppConfig (shouldn't happen in normal flow),
 * waits up to 3s for the promise to be set, then falls back to defaults.
 */
function waitForAppConfig() {
    if (_readyPromise)
        return _readyPromise;
    // Poll briefly in case we're called just before firebaseManager sets _readyPromise
    return new Promise(resolve => {
        let attempts = 0;
        const check = setInterval(() => {
            if (_readyPromise) {
                clearInterval(check);
                _readyPromise.finally(resolve);
            }
            else if (++attempts >= 30) { // 30 × 100ms = 3s max wait
                clearInterval(check);
                resolve(); // fall back to defaults
            }
        }, 100);
    });
}
exports.waitForAppConfig = waitForAppConfig;
function fetchAndActivateAppConfig(app) {
    _readyPromise = _fetchAndActivate(app, false);
    return _readyPromise;
}
exports.fetchAndActivateAppConfig = fetchAndActivateAppConfig;
/** Force a fresh RC fetch ignoring the 1-hour cache — used by MaintenanceScreen to detect recovery. */
function forceRefreshAppConfig() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!_firebaseApp)
            return;
        yield _fetchAndActivate(_firebaseApp, true);
    });
}
exports.forceRefreshAppConfig = forceRefreshAppConfig;
let _firebaseApp = null;
function _fetchAndActivate(app, force) {
    return __awaiter(this, void 0, void 0, function* () {
        _firebaseApp = app;
        try {
            const rc = (0, remote_config_1.getRemoteConfig)(app);
            rc.settings.minimumFetchIntervalMillis = force ? 0 : 3600000; // 1 hour normally
            rc.defaultConfig = {
                crew_feed_decay_half_life_days: exports.APP_CONFIG_DEFAULTS.decayHalfLifeDays,
                crew_feed_newness_bonus_points: exports.APP_CONFIG_DEFAULTS.newnessBonusPoints,
                crew_feed_newness_window_days: exports.APP_CONFIG_DEFAULTS.newnessWindowDays,
                crew_feed_reserved_slots: exports.APP_CONFIG_DEFAULTS.reservedSlots,
                crew_feed_reserved_max_age_hours: exports.APP_CONFIG_DEFAULTS.reservedMaxAgeHours,
                feature_quick_takes_enabled: exports.APP_CONFIG_DEFAULTS.featureQuickTakesEnabled,
                feature_watch_now_enabled: exports.APP_CONFIG_DEFAULTS.featureWatchNowEnabled,
                feature_this_or_that_enabled: exports.APP_CONFIG_DEFAULTS.featureThisOrThatEnabled,
                feature_waitlist_enabled: exports.APP_CONFIG_DEFAULTS.featureWaitlistEnabled,
                feature_import_enabled: exports.APP_CONFIG_DEFAULTS.featureImportEnabled,
                app_maintenance_mode: exports.APP_CONFIG_DEFAULTS.appMaintenanceMode,
                feature_glassmorphic_movie_card: exports.APP_CONFIG_DEFAULTS.featureGlassmorphicMovieCard,
            };
            yield (0, remote_config_1.fetchAndActivate)(rc);
            const n = (key, fallback) => {
                const v = (0, remote_config_1.getValue)(rc, key).asNumber();
                return Number.isFinite(v) && v > 0 ? v : fallback;
            };
            const b = (key, fallback) => {
                const raw = (0, remote_config_1.getValue)(rc, key);
                // Remote Config stores booleans as strings "true"/"false"
                if (raw.getSource() === 'default')
                    return fallback;
                return raw.asBoolean();
            };
            const s = (key, fallback, allowed) => {
                const raw = (0, remote_config_1.getValue)(rc, key);
                if (raw.getSource() === 'default')
                    return fallback;
                const v = raw.asString();
                return allowed.indexOf(v) !== -1 ? v : fallback;
            };
            _config = {
                decayHalfLifeDays: n('crew_feed_decay_half_life_days', exports.APP_CONFIG_DEFAULTS.decayHalfLifeDays),
                newnessBonusPoints: n('crew_feed_newness_bonus_points', exports.APP_CONFIG_DEFAULTS.newnessBonusPoints),
                newnessWindowDays: n('crew_feed_newness_window_days', exports.APP_CONFIG_DEFAULTS.newnessWindowDays),
                reservedSlots: n('crew_feed_reserved_slots', exports.APP_CONFIG_DEFAULTS.reservedSlots),
                reservedMaxAgeHours: n('crew_feed_reserved_max_age_hours', exports.APP_CONFIG_DEFAULTS.reservedMaxAgeHours),
                featureQuickTakesEnabled: b('feature_quick_takes_enabled', exports.APP_CONFIG_DEFAULTS.featureQuickTakesEnabled),
                featureWatchNowEnabled: b('feature_watch_now_enabled', exports.APP_CONFIG_DEFAULTS.featureWatchNowEnabled),
                featureThisOrThatEnabled: b('feature_this_or_that_enabled', exports.APP_CONFIG_DEFAULTS.featureThisOrThatEnabled),
                featureWaitlistEnabled: b('feature_waitlist_enabled', exports.APP_CONFIG_DEFAULTS.featureWaitlistEnabled),
                featureImportEnabled: s('feature_import_enabled', exports.APP_CONFIG_DEFAULTS.featureImportEnabled, ['shown', 'hidden', 'disabled']),
                appMaintenanceMode: b('app_maintenance_mode', exports.APP_CONFIG_DEFAULTS.appMaintenanceMode),
                featureGlassmorphicMovieCard: b('feature_glassmorphic_movie_card', exports.APP_CONFIG_DEFAULTS.featureGlassmorphicMovieCard),
            };
            console.log('[AppConfig] Remote Config activated:', _config);
        }
        catch (e) {
            console.warn('[AppConfig] Remote Config fetch failed, using defaults', e);
        }
    });
}
